import React from 'react';
import CardComponent from 'ps-components/Card/Card';
import classnames from 'classnames';
import { string, object, bool, func } from 'prop-types';

import './Card.scss';

Card.propTypes = {
  key: string,
  children: object,
  isEditing: bool,
  onDelete: func,
  title: string
};

export default function Card(props) {
  const { key, children, title, isEditing, onDelete } = props;

  function getContent() {
    return (
      <div className="dashboard-card__inner-container">
        <div className="dashboard-card__content">{children}</div>
      </div>
    );
  }

  return (
    <CardComponent id={key} key={key} className={classnames('dashboard-card', { 'is-editing': isEditing })}>
      {isEditing && (
        <span className="dashboard-card__settings">
          <i onClick={onDelete} className="dashboard-card__delete-icon icon-trash" />
        </span>
      )}
      <div className="dashboard-card__title">{title}</div>
      {getContent()}
    </CardComponent>
  );
}
